import { useQuery, UseQueryOptions } from "react-query";
import { EstimatedDividendResponse } from "../lib/DataTable.type";
import { axiosInstance } from "@src/api/axiosConfig";

const nodeApi = process.env.REACT_APP_API_URL;
const nestPath = process.env.REACT_APP_NEST_API_URL;

//* 경공매 상세 정보
export const useAuctionDetail = (auctionId: string | undefined, enabled?: boolean) => {
    const fetchAuctionDetail = async () => {
        if (!auctionId) throw new Error("auctionId가 필요합니다");

        const response = await axiosInstance.get(`${nodeApi}/items/v3/item/${auctionId}`, {
            timeout: 10000,
        });
        return response?.data;
    };

    return useQuery(["auctionDetail", auctionId], fetchAuctionDetail, {
        enabled: !!auctionId && enabled,
        retry: 3,
    });
};

const estimatedDividendApi = `${nestPath}/items/detail/{itemId}/estimated-dividend`;

const getBidAmount = (itemId: string): string => {
    if (typeof window === "undefined") return "";
    const bidAmounts = JSON.parse(sessionStorage.getItem("bidAmounts") || "{}");
    return bidAmounts[itemId] || "";
};

const fetchEstimatedDividend = async (itemId: string): Promise<EstimatedDividendResponse> => {
    const bidAmount = parseInt(getBidAmount(itemId).replace(/[^\d]/g, ""), 10) || 0;

    const response = await axiosInstance.get(estimatedDividendApi.replace("{itemId}", itemId), {
        params: { bidAmount: bidAmount && bidAmount > 0 ? bidAmount : undefined },
    });
    return response.data;
};

const useEstimatedDividendQuery = <TSelected = EstimatedDividendResponse>(
    itemId: string,
    select?: (res: EstimatedDividendResponse) => TSelected,
    options?: Omit<UseQueryOptions<EstimatedDividendResponse, Error, TSelected>, "queryKey" | "queryFn">,
) => {
    return useQuery<EstimatedDividendResponse, Error, TSelected>(
        ["estimatedDividend", itemId],
        () => fetchEstimatedDividend(itemId),
        {
            enabled: !!itemId,
            select,
            ...options,
        },
    );
};

export const useDividendAuctionPrice = (itemId: string) => useEstimatedDividendQuery(itemId, (res) => res.auctionPrice);

export const useEstimatedDividend = (itemId: string) => useEstimatedDividendQuery(itemId);

export const useLesseeDividendCaseNo = (itemId: string) => useEstimatedDividendQuery(itemId, (res) => res.lesseeListCaseNo);
